import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'react-flexbox-grid';

import { emptyStyle } from './NoEntriesText.less';

const NoEntriesText = ({ emptyText }) => (
  <Row center="xs" middle="xs" style={{ height: '20rem' }}>
    <Col xs={6}>
      <h5 className={emptyStyle}>
        <FormattedMessage id={emptyText} />
      </h5>
    </Col>
  </Row>
);

NoEntriesText.propTypes = {
  emptyText: PropTypes.string,
};

export default NoEntriesText;
